import apiClient from './client';

export interface ChurchDirectory {
  id: number;
  churchName: string;
  contactName?: string;
  contactPosition?: string;
  contactPhone?: string;
  contactEmail?: string;
  city?: string;
  state?: string;
  addressStreet?: string;
  addressStreet2?: string;
  addressCity?: string;
  addressState?: string;
  addressZip?: string;
  addressCountry?: string;
  churchPlanterId?: number;
  relationshipType?: 'sending' | 'supporting' | 'partnering' | 'other';
  relationshipNotes?: string;
  denomination?: string;
  website?: string;
  notes?: string;
  isActive: boolean;
  churchPlanter?: {
    id: number;
    name: string;
    email: string;
    city: string;
    state: string;
  };
  createdAt: string;
  updatedAt: string;
}

export interface ChurchDirectoryFilters {
  page?: number;
  limit?: number;
  search?: string;
  city?: string;
  state?: string;
  denomination?: string;
  relationshipType?: string;
  churchPlanterId?: number;
  isActive?: boolean;
}

export interface CreateChurchData {
  churchName: string;
  contactName?: string;
  contactPosition?: string;
  contactPhone?: string;
  contactEmail?: string;
  city?: string;
  state?: string;
  addressStreet?: string;
  addressStreet2?: string;
  addressCity?: string;
  addressState?: string;
  addressZip?: string;
  addressCountry?: string;
  churchPlanterId?: number;
  relationshipType?: 'sending' | 'supporting' | 'partnering' | 'other';
  relationshipNotes?: string;
  denomination?: string;
  website?: string;
  notes?: string;
}

export interface UpdateChurchData {
  churchName?: string;
  contactName?: string;
  contactPosition?: string;
  contactPhone?: string;
  contactEmail?: string;
  city?: string;
  state?: string;
  addressStreet?: string;
  addressStreet2?: string;
  addressCity?: string;
  addressState?: string;
  addressZip?: string;
  addressCountry?: string;
  churchPlanterId?: number;
  relationshipType?: 'sending' | 'supporting' | 'partnering' | 'other';
  relationshipNotes?: string;
  denomination?: string;
  website?: string;
  notes?: string;
  isActive?: boolean;
}

class ChurchDirectoryService {
  async getAllChurches(filters: ChurchDirectoryFilters = {}) {
    const response = await apiClient.get('/church-directory', { params: filters });
    return response.data;
  }

  async getChurch(id: number) {
    const response = await apiClient.get(`/church-directory/${id}`);
    return response.data;
  }

  async createChurch(data: CreateChurchData) {
    const response = await apiClient.post('/church-directory', data);
    return response.data;
  }

  async updateChurch(id: number, data: UpdateChurchData) {
    const response = await apiClient.put(`/church-directory/${id}`, data);
    return response.data;
  }

  async deleteChurch(id: number) {
    const response = await apiClient.delete(`/church-directory/${id}`);
    return response.data;
  }

  async getChurchesByPlanter(planterId: number) {
    const response = await apiClient.get(`/church-directory/by-planter/${planterId}`);
    return response.data;
  }

  async getChurchesByLocation(city?: string, state?: string) {
    const response = await apiClient.get('/church-directory/by-location', {
      params: { city, state },
    });
    return response.data;
  }

  async getChurchesByDenomination(denomination: string) {
    const response = await apiClient.get(`/church-directory/by-denomination/${denomination}`);
    return response.data;
  }
}

export const churchDirectoryService = new ChurchDirectoryService();

